import * as types from "../actions/actionTypes";

const initialState = {
  razorpay: null,
  paymentDetails: null,
};

const razorpay = (state = initialState, action) => {
  switch (action.type) {
    case types.CREATE_RAZORPAY:
      return { ...state, razorpay: null };
    case types.CREATE_RAZORPAY:
      return { ...state, razorpay: null };
    case types.FETCH_PAYMENT:
      return { ...state, paymentDetails: null };
    case types.PEYMENT_DETAILS_RESPONSES:
      return { ...state, paymentDetails: action?.data };
    default:
      return state;
  }
};

export default razorpay;
